export default {
  SET_SUPPLIERS: (state, { suppliers }) => {
    state.suppliers = suppliers
  }
}
